import { JinroRoles } from "./jinro-roles";

export const JinroTeamRoles: Array<JinroRoles> = [
  JinroRoles.Jinro,
  JinroRoles.Kyojin,
];
